import MaterialIcon from "./MaterialIcon";

interface Props {
  isActive?: boolean;
  iconName: string;
  tooltipText?: string;
  isMenu?: boolean;
  className?: string;
  type?: "outlined" | "filled";
  onClick?: () => void;
}

function WorkflowEmailToolbarButton(props: Props) {
  const { isActive, iconName, tooltipText, isMenu, className, type, onClick } = props;

  return (
    <div className={`group relative flex items-center justify-center ${isMenu ? "w-10" : "w-7"} h-7 cursor-pointer rounded ${isActive ? "bg-gray-200" : "hover:bg-gray-100"} ${className}`} onClick={onClick}>
      <MaterialIcon name={iconName} className={`text-[20px] ${isActive ? "text-black" : "text-gray-700"}`} type={type || "filled"} />
      {isMenu &&
        <MaterialIcon name="arrow_drop_down" className={`w-[16px] text-[20px] ${isActive ? "text-black" : "text-gray-700"}`} />
      }
      {tooltipText &&
        <span className={`invisible ${!isActive && "group-hover:visible"} bg-gray-600 text-xs text-white text-center rounded py-1 px-2 absolute left-0 z-50 bottom-full whitespace-nowrap`}>{tooltipText}</span>
      }
    </div >
  );
}

export default WorkflowEmailToolbarButton;
